// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"515":"1a03d203","944":"0daeb63a"}[chunkId] + ".chunk.css";
};